import { MutationKeyConfig, QueryKeyConfig } from '../api-helper';

export const rolesApiKeyStore = {
  createRole: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_ROLES`],
    route: `/role`,
    action: 'POST',
  }),
  updateRole: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_ROLES`],
    route: `/role`,
    action: 'PUT',
  }),
  deleteRole: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_ROLE`, id],
    route: `/role/${id}`,
    action: 'DELETE',
  }),
  getRoles: (): QueryKeyConfig => ({
    queryKey: [`GET_ROLES`],
    route: `/role`,
  }),
  getPermissions: (): QueryKeyConfig => ({
    queryKey: [`GET_PERMISSIONS`],
    route: `/role/Permissions`,
  }),
};
